import React from 'react';
import { Colors } from 'library';
import { Card, Icon, Row, Text } from 'library/ui';
import { Check } from '@mui/icons-material';

export default function SuccessMessage({ visible }: { visible: boolean }) {
    if (!visible) return null;
    return (
        <Card padding="sm" tone="secondary">
            <Row gap="sm">
                <Icon icon={Check} size="sm" bgColor={Colors.secondary} iconColor={Colors.white} />
                <Text>Good news! We found some great teachers near you!</Text>
            </Row>
        </Card>
    );
}
